import { transformNullishFromData } from "@/utils/transforms";


export default {
    state: {
        default: {
            id: 0,
            user: null,
            userId: 0,
            competence: null,
            previousMonthBalance: null,
            input: null,
            outputDistributed: null,
            currentBalance: 0,
            quantityRequested: null,
            supplyId: 0,
            supply: null,
            statusId: 0,
            status: null,
            observation: null,
        },
        data: {

        },
    },

    getters: {
        getCondomSolicitationData(state) {
            return state.data;
        },
        getDefaultCondomSolicitationData(state) {
            return state.default;
        },
    },

    mutations: {
        resetOrPersistCondomSolicitationData(state, data) {
            state.data = transformNullishFromData(data);
        },

    },

    actions: {
        changeCondomSolicitationData(context, info) {
            context.commit("resetOrPersistCondomSolicitationData", info);

        },

    },

}

// modulo toda hora volta o nome em mauisculo                                                     